/**
 * The status-save contract shared by the side panel's status block and the status service
 * (design spec 9.2, 9.6). Types and constants only: nothing here may import firebase, a store,
 * `$lib/utils/api` or a `.svelte` file, so the block stays renderable from props alone.
 */
import type { StatusRecord, StoredStatus } from "./status";

/** What a reviewer can pick: the three stored values plus `open`, which deletes the record. */
export type SettableStatus = "open" | StoredStatus;

/** The select's order: `open` first, then the stored values. */
export const SETTABLE_STATUSES: readonly SettableStatus[] = ["open", "acknowledged", "resolved", "dismissed"];

/** The route's note cap, checked after trim. */
export const STATUS_NOTE_MAX_LENGTH = 1000;

/**
 * How one save ended.
 * - `saved`: 200 with the parsed record, or `record: undefined` on 204 (`open`).
 * - `swept`: 404, the latest publish no longer lists the row.
 * - `failed`: anything else (403, 422, 5xx, network, an unparseable 200).
 */
export type StatusSaveOutcome =
  | { kind: "saved"; record: StatusRecord | undefined }
  | { kind: "swept" }
  | { kind: "failed" };

/** Saves one row's status: the callback the container hands the panel and the panel the block. */
export type SaveStatus = (status: SettableStatus, note: string) => Promise<StatusSaveOutcome>;
